import React from 'react';
import Select from 'react-select';
import SelectAsync from 'react-select/async';

const DropdownIndicator = () => {
    return <img src="/img/ic_arrow_down1.svg" alt="img" />
};

function SelectWrapper(props) {
    return <Select classNamePrefix={'dsa-select'} components={{
        DropdownIndicator,
    }} {...props}/>
}

function SelectAsyncWrapper(props) {
    return <SelectAsync classNamePrefix={'dsa-select'} components={{
        DropdownIndicator,
    }} {...props}/>

}

export default SelectWrapper;

export {SelectAsyncWrapper};